import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '../../assets/emanta_logo.png';
const _hoisted_1 = { class: "bg-gray-100" };
const _hoisted_2 = { class: "flex flex-col items-center justify-center h-screen px-6 py-8 mx-auto lg:py-0" };
const _hoisted_3 = { class: "flex items-center mb-6 text-2xl font-semibold text-gray-900" };
const _hoisted_4 = ["alt"];
const _hoisted_5 = { class: "w-full bg-white border rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0" };
const _hoisted_6 = { class: "p-6 space-y-4 md:space-y-6 sm:p-8" };
const _hoisted_7 = { class: "flex flex-col" };
const _hoisted_8 = {
    for: "email",
    class: "block mb-2 text-sm font-medium text-gray-900"
};
const _hoisted_9 = { class: "flex flex-col" };
const _hoisted_10 = {
    for: "password",
    class: "block mb-2 text-sm font-medium text-gray-900"
};
const _hoisted_11 = { class: "flex items-center justify-between" };
const _hoisted_12 = { class: "flex flex-col w-full" };
const _hoisted_13 = {
    key: 0,
    class: "w-full pb-3 text-sm text-center text-red-400"
};
const _hoisted_14 = ["disabled"];
const _hoisted_15 = {
    key: 0,
    class: "animate animate-bouncing"
};
const _hoisted_16 = { key: 1 };
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import posthog from "posthog-js";
import { useToast } from "vue-toastification";
import { useAuthStore } from "@/domains/auth";
export default /*@__PURE__*/ _defineComponent({
    ...{ name: "AuthLogin" },
    __name: 'Login',
    setup(__props) {
        const router = useRouter();
        const { t } = useI18n();
        const toast = useToast();
        const authStore = useAuthStore();
        const form = reactive({ email: "", password: "" });
        const errorMessage = ref("");
        const loading = ref(false);
        async function submit() {
            if (loading.value)
                return;
            loading.value = true;
            errorMessage.value = "";
            try {
                await authStore.login(form.email, form.password);
                if (authStore.user)
                    posthog.identify(authStore.user.user_id);
                if (authStore.shouldSelectOrganization || !authStore.currentOrgId) {
                    router.push("/select-organization");
                }
                else {
                    router.push("/admin");
                }
                toast.success(t("shell.auth.login.success"), {
                    timeout: 3000,
                    position: "top-right",
                });
            }
            catch (error) {
                const message = error?.response?.data?.message
                    ?? translateAuthError(authStore.error);
                errorMessage.value = message;
            }
            finally {
                loading.value = false;
            }
        }
        function translateAuthError(message) {
            if (!message) {
                return t("shell.auth.login.error");
            }
            const keyByLegacyMessage = {
                "Credenciales inválidas o error de servidor": "shell.auth.login.invalid_credentials",
                "Error al cargar el perfil de usuario": "shell.auth.login.profile_load_error",
            };
            const key = keyByLegacyMessage[message];
            return key ? t(key) : message;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("section", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("a", _hoisted_3, [
                            _createElementVNode("img", {
                                class: "h-16 mr-2 w-18",
                                src: _imports_0,
                                alt: _unref(t)('shell.auth.login.logo_alt')
                            }, null, 8, _hoisted_4)
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("form", {
                                    class: "space-y-4 md:space-y-6",
                                    onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event) => (submit()), ["prevent"]))
                                }, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(t)("shell.auth.login.email_label")), 1),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "email",
                                            name: "email",
                                            id: "email",
                                            class: "bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5",
                                            placeholder: "emanta@emanta.com",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.email) = $event)),
                                            required: ""
                                        }, null, 512), [
                                            [_vModelText, form.email]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(t)("shell.auth.login.password_label")), 1),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "password",
                                            name: "password",
                                            id: "password",
                                            placeholder: "••••••••",
                                            class: "bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5",
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.password) = $event)),
                                            required: ""
                                        }, null, 512), [
                                            [_vModelText, form.password]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("a", {
                                            href: "/password-reset",
                                            class: "text-sm font-medium text-primary-600 hover:underline dark:text-primary-500",
                                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (_unref(router).push('/password-reset')), ["prevent"]))
                                        }, _toDisplayString(_unref(t)("shell.auth.login.forgot_password")), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_12, [
                                        (errorMessage.value)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(errorMessage.value), 1))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("button", {
                                            type: "submit",
                                            disabled: loading.value,
                                            class: "w-full text-white bg-eorange-400 hover:bg-eorange-600 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                        }, [
                                            (loading.value)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_unref(t)("shell.auth.login.loading")), 1))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_unref(t)("shell.auth.login.submit")), 1))
                                        ], 8, _hoisted_14)
                                    ])
                                ], 32)
                            ])
                        ])
                    ])
                ])
            ]));
        };
    }
});
